import React, { FC, useEffect, useState } from 'react'
import { Column } from 'react-table'
import Table from '../../components/Table';
import { Button, Container, FormHelperText, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import { GlobalSearchResult } from '../../api/mobilbase/models';
import { SubmitHandler, useForm } from 'react-hook-form';
import LoadingButton from '../../components/buttons/LoadingButton';
import * as globalSearch from '../../api/mobilbase/globalSearch';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/da";
import NoDataDialog from '../../components/dialogs/ErrorDialog';
import APIRequest from '../../components/helpers/APIRequest';

moment.locale("da");

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    buts: {
        width: '100%',
        height: '100%'
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    textHelp: {
      marginBottom: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(2),
    }
  }));

type FormValues = {
    pladeNumber: string;
    cardNumber: string;
}

type Props = {}

const GlobalSearch: FC<Props> = () => {
    const classes = useStyles();
    // const {selectedLocationId, selectedLocationName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
    const [data, setData] = useState<GlobalSearchResult[]>([]);
    const [isPending, setIsPending] = useState(false);
    const [run, setRun] = useState(false);
    const [open, setOpen] = React.useState(false);
    const { register, handleSubmit } = useForm<FormValues>();
    const [formData, setForData] = useState({pladeNumber: "", cardNumber: ""});

    const [selectedStartDate, handleStartDateChange] = useState<Date | null>(moment().toDate());
    const [selectedEndDate, handleEndDateChange] = useState<Date | null>(moment().toDate());

    useEffect(() => {
      if (!run && isPending) {
        if (data.length === 0) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      }
    }, [run, isPending, data.length])

    const columns: Column<GlobalSearchResult>[] = React.useMemo(
        () => [
          { Header: 'Plads', id: "0", accessor: 'locationName'}, 
          { Header: 'Automat', id: "1", accessor: 'deviceID' },
          { Header: 'Handling', id: "2", accessor: 'exData'},
          { Header: 'Tidspunkt', id: "3", accessor: 'time'},
          { Header: 'RegNr', id: "4", accessor: 'pladeNumber'},
          { Header: 'KortNr', id: "5", accessor: 'cardNumber'},
          { Header: 'Start', id: "6", accessor: 'start'},
          { Header: 'Stop', id: "7", accessor: 'stop'},
          { Header: 'Beløb', id: "8", accessor: 'amount'}
        ],
        []
      );

    const setDateButtons = (daysBack: number) => {
        handleStartDateChange(moment().subtract(daysBack, 'days').toDate());
        handleEndDateChange(moment().toDate());
    }

    const onSubmit: SubmitHandler<FormValues> = async (data) => {
      setForData({pladeNumber: data.pladeNumber, cardNumber: data.cardNumber});
      setRun(true);
      }

    const handleCloseOffline = () => {
        setOpen(false);
    };

    const RequestData = () => {
      return (
        <APIRequest<GlobalSearchResult[]>
            run={run}
            setRun={setRun}
            pending={isPending}
            setIsPending={setIsPending}
            req={() => globalSearch.getLocationOverview({
              body: {
                pladeNumber: formData.pladeNumber,
                cardNumber: formData.cardNumber,
                start: (selectedStartDate) ? selectedStartDate : moment().toDate(),
                end: (selectedEndDate) ? selectedEndDate : moment().toDate(),
              }
            })}
            setData={setData}
        />
      );
    }

    return (
        <Container maxWidth={false}>
          <RequestData />
            <div className={classes.paper}>
            <Typography component="h1" variant="h5">
                {/* Global søgning */}
                Parkant opslag
            </Typography>
            <Container maxWidth={"lg"} className={classes.margTop}>
            {/* <div className={classes.paper}> */}
            {/* <Typography component="h4" variant="h5">
                Der kan kun søges på enten
            </Typography> */}
            <form  noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                <TextField
                    autoComplete="pladeNumber"
                    name="pladeNumber"
                    variant="outlined"
                    fullWidth
                    id="pladeNumber"
                    label="Registreringsnummer"
                    autoFocus
                    inputRef={register}
                />
                </Grid>
                <Grid item xs={12} sm={6}>
                <TextField
                    variant="outlined"
                    fullWidth
                    id="cardNumber"
                    label="Kortnummer"
                    name="cardNumber"
                    autoComplete="cardNumber"
                    inputRef={register}
                />
                <FormHelperText className={classes.textHelp} id="component-helper-text">*Søg på enten de 6 første cifre fx: 457123 eller hele nummeret fx: 457123XXXXXX1919</FormHelperText>
                </Grid>
            </Grid>
            {/* <Paper className={classes.paper}> */}
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(0)}>I dag</Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(7)}>Sidste 7 dage</Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(14)}>Sidste 14 dage</Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(30)}>Sidste 30 dage</Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(90)}>Sidste 90 dage</Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant="contained" color="primary" className={classes.buts} onClick={() => setDateButtons(180)}>Sidste 180 dage</Button>
                    </Grid>
                </Grid>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={'da'}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <DatePicker
                            className={classes.margTop}
                            fullWidth
                            inputVariant="outlined"
                            label="Start dato"
                            value={selectedStartDate}
                            onChange={date => handleStartDateChange(date)}
                            // onChange={handleStartDateChange}
                            animateYearScrolling
                            minDate={moment().subtract(6, 'months').toDate()}
                            maxDate={selectedEndDate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DatePicker
                            className={classes.margTop}
                            fullWidth
                            inputVariant="outlined"
                            label="Slut dato"
                            value={selectedEndDate}
                            onChange={date => handleEndDateChange(date)}
                            animateYearScrolling
                            minDate={selectedStartDate}
                            maxDate={moment().toDate()}
                        />
                    </Grid>
                </Grid>
                </MuiPickersUtilsProvider>
            {/* </Paper> */}
                <div className={classes.margTop} >
                    <LoadingButton update={() => {}} pending={isPending} text={"Søg"}/>
                </div>

              </form>
            {/* </div> */}
          </Container>
          <div className={classes.grid}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table<GlobalSearchResult> columns={columns} data={mapSearchData(data)} initialState={{}} clickEvent={() => {}} update={null} pending={false} text={""}/>
                </Grid>
              </Grid>
            </div>
          </div>
          <NoDataDialog open={open} onClose={handleCloseOffline} title={"Ingen resultater"} text={"Der kunne ikke findes nogle resultater for denne søgning"}/>
        </Container>
      );
}

const mapSearchData = (data: GlobalSearchResult[]) => {
  if (!data) {
    return [];
  }

  if (data.length === 0) {
    return [];
  }

  return data.map(d => {
    var l = {...d};
    l.locationName = (!l.locationName) ? "-" : l.locationName;
    l.deviceID = (!l.deviceID) ? "-" : +l.deviceID;
    l.pladeNumber = (!l.pladeNumber) ? "-" : l.pladeNumber;
    l.cardNumber = (!l.cardNumber) ? "-" : l.cardNumber;
    l.start = (!l.start) ? "-" : moment(l.start).format("DD-MM-YYYY HH:mm");
    l.stop = (!l.stop) ? "-" : moment(l.stop).format("DD-MM-YYYY HH:mm");
    l.amount = (l.amount === null) ? "-" : +l.amount;
    l.exData = (!l.exData) ? "-" : l.exData;

    l.time = moment(l.time).format("DD-MM-YYYY HH:mm");

    return l;
  });
}

export default GlobalSearch;